<script>
import IconChevron from './IconChevron.vue';
import LoadingSpinner from './LoadingSpinner.vue';

export default {
    name: 'SeriesSelectorThankYou',
    components: { LoadingSpinner, IconChevron },
    props: {
        backToStartButtonText: { type: String, default: null },
        results: { type: Array, default: () => [] },
        title: { type: String, default: null },
        isLoading: { type: Boolean, default: false },
    },
    emits: ['go-back-to-start', 'configure-truck'],
};
</script>

<template>
    <div class="series-selector__results">
        <div class="text row">
            <div class="col-12 col-md-6 mb-0">
                <h3 class="h2 font-weight-bold">{{ title }}</h3>
            </div>
        </div>

        <div class="border-bottom mb-4">
            <button class="previous d-flex align-items-center" @click="$emit('go-back-to-start')">
                <IconChevron />
                <span>{{ backToStartButtonText }}</span>
            </button>
        </div>

        <div v-if="isLoading" class="series-selector__results-loader d-flex justify-content-center align-items-center">
            <LoadingSpinner />
        </div>
        <div v-else>
            <ul v-if="results.length > 0" class="results-list mb-3">
                <li v-for="model in results" :key="model.Id" class="result d-flex-column d-s-flex">
                    <figure>
                        <img :src="model.ImageUrl" :alt="`DAF ${model.Name}`" />
                    </figure>
                    <div class="result__text">
                        <h4 class="h3">{{ model.Name }}</h4>
                        <p>{{ model.Description }}</p>
                        <a
                            class="btn btn-link"
                            :href="model.ConfigureLinkUrl"
                            target="_blank"
                            @click="$emit('configure-truck', model.Name)"
                        >
                            {{ model.ConfigureLinkText }}
                        </a>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>